import type { CurrentFreshness, DatasetFreshness } from '../types/freshness'
import { withCurrentFreshness } from '../utils/freshness'

const FRESHNESS_PATH = '/data/freshness.json'

let freshnessPromise: Promise<CurrentFreshness> | null = null

async function fetchJson<T>(path: string, options: { forceRefresh?: boolean } = {}) {
  const response = await fetch(path, {
    cache: options.forceRefresh ? 'no-store' : 'default',
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) throw new Error(`数据新鲜度元数据请求失败（${response.status}）`)
  return response.json() as Promise<T>
}

export function loadDatasetFreshness(options: { forceRefresh?: boolean } = {}) {
  if (options.forceRefresh || freshnessPromise === null) {
    freshnessPromise = fetchJson<DatasetFreshness>(FRESHNESS_PATH, options).then((payload) => withCurrentFreshness(payload))
  }
  return freshnessPromise
}

export function resetFreshnessCache() {
  freshnessPromise = null
}
